// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3H9P4","header":"Messages_header__1u51d"};